import { Button, Box, Typography, SvgIcon } from "@mui/material";
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  HighlightOffOutlined as HighlightOffOutlinedIcon,
} from "@mui/icons-material";

const SuccessAndFaildCreatePatient = ({
  messageSuccess,
  name,
  surname,
  creationStatus,
  handreToLanding,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SvgIcon
        sx={{
          color: creationStatus === "succeeded" ? "#32BA7C" : "#FF0000",
          fontSize: 80,
        }}
      >
        {creationStatus === "succeeded" ? (
          <CheckCircleOutlineIcon />
        ) : (
          <HighlightOffOutlinedIcon />
        )}
      </SvgIcon>
      <Typography
        sx={{
          fontWeight: 500,
          textAlign: "center",
          fontFamily: `"Inter", sans-serif`,
          color: "text.black",
          fontSize: 30,
          p: 1,
        }}
      >
        {creationStatus === "succeeded"
          ? "Muchas gracias!"
          : "Opss! Algo salió mal..."}
      </Typography>

      <Typography
        sx={{
          textAlign: "center",
          fontFamily: `"Inter", sans-serif`,
          color: "text.black",
          fontSize: 14,
          minWidth: { xs: "auto", sm: 200 },
          maxWidth: { xs: "auto", sm: 310 },
          p: 1,
          mt: 2,
          mb: 3,
        }}
      >
        {creationStatus === "succeeded" ? (
          <>
            {messageSuccess}{" "}
            <strong>
              {name} {surname}
            </strong>
          </>
        ) : (
          "Por favor, verifique sus datos o vuelva a intentarlo en unos minutos..."
        )}
      </Typography>

      <Button variant="contained" onClick={handreToLanding}>
        Volver al Inicio
      </Button>
    </Box>
  );
};

export default SuccessAndFaildCreatePatient;
